import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Theme from 'styles/theme';

import { SIZES } from './constants';

export { SIZES };

const CloseIcon = ({ size, disableHoverAnimation, className }) => (
  <span
    className={classNames('CloseIcon', className, {
      'CloseIcon--hoverable': !disableHoverAnimation,
    })}
  >
    <style jsx>
      {`
        .CloseIcon {
          position: relative;
          height: ${size}px;
          width: ${size}px;
          text-indent: -9999em;
          background-color: transparent;
          display: inline-block;
        }

        .CloseIcon:focus {
          outline: none;
        }

        .CloseIcon.focused {
          outline: 2px solid ${Theme.get('colors-black')};
        }

        .CloseIcon:before,
        .CloseIcon:after {
          content: '';
          position: absolute;
          width: ${Theme.get('spacing') / 3}px;
          top: 50%;
          left: 50%;
          height: ${size}px;
          background-color: ${Theme.get('colors-black')};
          transition: transform ease-in-out ${Theme.get('transition-duration-ms')};
        }

        .CloseIcon:before {
          transform: translate(-50%, -50%) rotate(45deg);
        }

        .CloseIcon:after {
          transform: translate(-50%, -50%) rotate(-45deg);
        }

        .CloseIcon--hoverable:hover:before,
        .CloseIcon--hoverable:focus:before {
          transform: translate(-50%, -50%) rotate(135deg);
        }

        .CloseIcon--hoverable:hover:after,
        .CloseIcon--hoverable:focus:after {
          transform: translate(-50%, -50%) rotate(45deg);
        }
      `}
    </style>
  </span>
);

CloseIcon.propTypes = {
  size: PropTypes.oneOf(Object.values(SIZES)),
  disableHoverAnimation: PropTypes.bool,
  className: PropTypes.string,
};

CloseIcon.defaultProps = {
  size: SIZES.LARGE,
  disableHoverAnimation: false,
  className: null,
};

export default CloseIcon;
